import _ from "lodash";

export default function(state = this.initialValue, action) {
    switch (action.type) {
        case this.selectedAction:
            return {...state, ..._.mapKeys(action.payload.data.data, this.key)}
        default:
            return state;
    }
};